module Meevo.Plugins.MeevoMessengerSettings {
    'use strict';

    export interface IMeevoMessengerSettingsTwoWaySmsSection extends Meevo.Components.CommonClasses.ICommonSection {
        initialSetup: () => void;
    }

    export class TwoWaySmsSection extends Meevo.Components.CommonClasses.CommonSectionBase implements IMeevoMessengerSettingsTwoWaySmsSection {
        public params: ISectionParamsMeevoMessengerSettings;
        public isFormProcessed = true;
        public disableCrud: boolean;

        constructor(
            params: ISectionParamsMeevoMessengerSettings,
            protected $filter: angular.IFilterService,
            protected $translate: angular.translate.ITranslateService,
            protected meevoMessengerSettingsService: IMeevoMessengerSettingsService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $scope: angular.IScope,
            protected $q: angular.IQService
        ) {
            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.noun,
                params.identityService,
                params.sectionSecurityKey);

            this.params = params;
        }

        edit() {
            this.$scope.$broadcast('EDIT_MODE_SETTINGS');
        }

        save() {
            this.$scope.$broadcast('SAVE_MODE_SETTINGS');
        }

        cancel() {
            this.$scope.$broadcast('CANCEL_MODE_SETTINGS');
        }

        preSave(): any {
            this.$scope.$broadcast('PRE_SAVE_MODE_SETTINGS');
        }

        initialSetup() {
            console.log('Initialized 2WS');
        }

        get isAccountInitialized() {
            return this.model && this.model.isAccountInitialized
        }
    }
}
